import React, {FC, useEffect, useState} from "react";
import {Option} from "../../models/SGB";
import {OptionSorter} from "../../models/Quote";
import AppUtil from "../../util/AppUtil";
import {TimeUtil} from "../../util/TimeUtil";
import TickManager, {useSub} from "../../service/TickManager";
import {DropDownCompNumber, DropDownCompString, getKeyVal, getKeyValArray} from "../util/DropDownComp";
import AppConstants from "../../util/AppConstants";
import GatewayService from "../../service/GatewayService";
import {CheckboxComponent} from "../util/CheckboxComponent";
import {ComboList} from "./OptionsOppComponent";
import {useClients} from "../../context/ClientsContext";
import {useChain} from "../../context/ChainContext";
import {Combo} from "../../models/Combo";
import {toast, Toaster} from "react-hot-toast";

interface Prop {
    option:Option,
    clientId:string,
    enableTrading:boolean,
    getCombos: (s:string)=>void
}

const OptionRowComponent : FC<Prop> = (prop: Prop) => {
    const opt = prop.option
    const clientId = prop.clientId
    const [option, setOption] = useState(opt)
    const [exposure, setExposure] = useState(-1)
    useSub(option.genInfo.tradingsymbol, setOption)
    const fut = TickManager.getFuture(opt.genInfo.tradingsymbol)

    function getExposure() {
        GatewayService.getMargin(opt.miniTick.token).then(ch=>setExposure(ch.exposure))
    }

    let buyer = AppUtil.maxBuyer(option);
    let seller = AppUtil.minSeller(option);

    function buy(price: number) {
        GatewayService.buyInst(option.genInfo, price, clientId)
    }

    function sell(price: any) {
        GatewayService.sellInst(option.genInfo, price, clientId)
    }

    let waoSeller = seller===0?false : seller<opt.intrinsic
    let row = <tr>
        <td>{TimeUtil.fromNano(option.miniTick.nanoTime)}</td>
        <td onClick={()=> console.log(option)}>{option.genInfo.name}</td>
        <td>{option.genInfo.strike}</td>
        <td onClick={()=>toast(`token is ${option.genInfo.token}`)}>{option.genInfo.tradingsymbol}</td>
        {/*<td>{option.genInfo.tradingsymbolAngel}</td>*/}
        {
            prop.enableTrading?<>
                <td><button onClick={()=>buy(buyer)}>+</button>{buyer}<button onClick={()=>sell(buyer)}>-</button></td>
                <td><button onClick={()=>buy(seller)}>+</button>{seller}<button onClick={()=>sell(seller)}>-</button></td>
                </> :
                <>
                    <td>{buyer}</td>
                    <td>{seller}</td>
                </>
        }
        <td>{(seller-buyer).toFixed(2)}</td>
        <td>{option.diff.toFixed(2)}</td>
        <td>{option.miniTick.lastPrice}</td>
        <td>{option.extrinsicBuy.toFixed(1)}</td>
        <td>{option.extrinsicSell.toFixed(1)}</td>
        <td>{option.intrinsic.toFixed(1)}</td>
        <td>{fut?.miniTick.lastPrice}</td>
        <td>{option.miniTick.buyQty}/{option.miniTick.sellQty}</td>
        {/*<td>{AppUtil.getTime(option.tick.last_trade_time)}</td>*/}
        <td>{AppUtil.getTime(option.genInfo.expiry)}</td>
        <td>{option.genInfo.lot_size*option.genInfo.hidden_lot_size}</td>
        {/*<td>{AppUtil.getRoundedOff(option.genInfo.exposure)}</td>*/}
        {/*<td>{AppUtil.getRoundedOff(exposure)}</td>*/}
        {/*<td><button onClick={()=>getExposure()}>getExposure</button></td>*/}
        <td><button onClick={()=>prop.getCombos(option.genInfo.tradingsymbol)}>getCombos</button></td>
    </tr>

    return row


}

interface Props {
}
const defaultSorter = AppUtil.genericSorter("", true)

const AllOptionComponent:FC<Props> = (props) => {
    const { clients } = useClients();
    const { chain, setChain } = useChain();
    const [options, setOptions] = useState<Array<Option>>(TickManager.getAllOptions())
    //if initial state is a function, its invoked
    const [clientId, setClientId] = useState("")
    const [enableTrading, setEnableTrading] = useState(false)
    const [onlyOpenPositions, setonlyOpenPositions] = useState(false)
    const [positions, setPositions] = useState<Array<String>>([])
    const [showOnlyWao, setShowOnlyWao] = useState(false)
    const [showWithBuyers, setBuyersAvailable] = useState(false)
    const [onlyITM, setonlyITM] = useState(false)
    const [showWithSellers, setSellersAvailable] = useState(false)
    const [expiry, setExpiry] = useState(-1);
    const [sorter, setSorter] = useState<OptionSorter>(()=>defaultSorter)
    const[exchange, setExchange] = useState("");
    const[CE, setCE] = useState(true);
    const[PE, setPE] = useState(true);
    const[FUT, setFUT] = useState(false);
    const [combos, setCombos] = useState<Array<Combo>>([]);
    const [tradingsymbol, setTradingsymbol] = useState("");

    function getCombos(option:String){
        GatewayService.getCombos(option).then(setCombos)
    }
    function refresh() {
        let arr = [...TickManager.getAllOptions()]
        setOptions(arr)
    }

    useEffect(() => {
        TickManager.subscribeOptions((updatedOptions) => {
            setOptions([...updatedOptions]);
        });
    }, []);

    useEffect(() => {
        if (clients && clients.length > 0 && clientId === "") {
            setClientId(clients[0]);
        }
    }, [clients, clientId]);

    useEffect(()=>{
        if(showOnlyWao) {
            setFUT(false)
            setCE(true)
            setPE(true)
        }else{
            setFUT(true)
            setCE(false)
            setPE(false)
        }
    }, [showOnlyWao])

    function getOptions():Array<Option>{
        return options.sort((a,b)=>{
            return sorter(a,b)
        })
            .filter(it=>it.genInfo.expiry===expiry || expiry===-1)
            .filter(it=>it.genInfo.exchange===exchange || exchange==="")
            .filter(it => {
                let seller = AppUtil.minSeller(it);
                let options = (it.genInfo.instrument_type==="CE" && CE) || (it.genInfo.instrument_type==="PE"&&PE) || (it.genInfo.instrument_type==="FUT"&&FUT)
                return (!showOnlyWao || (showOnlyWao && it.intrinsic>seller && seller!==0) ) && options
            } ).filter(it=>!onlyOpenPositions || positions.indexOf(it.genInfo.tradingsymbol)!==-1)
            .filter(it=> !showWithBuyers || AppUtil.maxBuyer(it)!==0)
            .filter(it=> !showWithSellers || AppUtil.minSeller(it)!==0)
            .filter(it => !onlyITM || it.intrinsic>0 || it.genInfo.instrument_type===AppConstants.FUT)
            .filter(it => tradingsymbol === "" || it.genInfo.tradingsymbol.toLowerCase().includes(tradingsymbol.toLowerCase()))
            .filter(it => chain === "" || it.genInfo.name.toLowerCase()===(chain.toLowerCase()))
    }
    function getExpires(){
        let set =  new Set(getOptions().map(it=>it.genInfo.expiry))
        return getKeyValArray(Array.from(set.values()).sort(AppUtil.sort), (it)=> AppUtil.getTime(it))
    }

    function getExchanges(){
        let set = new Set(options.map(it=>it.genInfo.exchange))
        return getKeyValArray(Array.from(set.values()).sort(), (it)=> it)
    }

    function getClients(){
        return getKeyVal(clients || []);
    }

    function refreshITM() {
        TickManager.refreshIntrinsics()
        refresh()
    }

    return<>
        <div className={"tab"}>tradingsymbol = <input type="text" value={tradingsymbol} onChange={event => setTradingsymbol(event.target.value)} className="auto-expand-input" /></div>
        <div className={"tab"}>chain = <input type="text" value={chain} onChange={event => setChain(event.target.value)} className="auto-expand-input"/></div>
        <DropDownCompNumber text={"select buy expiry"} actual={expiry} arr={getExpires()} set={setExpiry}/>
        <CheckboxComponent text={"enable trading"} actual={enableTrading} val={enableTrading} set={setEnableTrading}/>
        <CheckboxComponent text={"onlyWao"} actual={showOnlyWao} val={showOnlyWao} set={setShowOnlyWao}/>
        <CheckboxComponent text={"buyers available"} actual={showWithBuyers} val={showWithBuyers} set={setBuyersAvailable}/>
        <CheckboxComponent text={"sellers available"} actual={showWithSellers} val={showWithSellers} set={setSellersAvailable}/>
        <CheckboxComponent text={"itm"} actual={onlyITM} val={onlyITM} set={setonlyITM}/>
        <CheckboxComponent text={"positions"} actual={onlyOpenPositions} val={onlyOpenPositions} set={setonlyOpenPositions}/>
        <DropDownCompString text={"client"} actual={clientId} arr={getClients()} set={setClientId}/>
        <DropDownCompString text={"exchange"} actual={exchange} arr={getExchanges()} set={setExchange}/>
        <CheckboxComponent text="CE" actual={CE} val={CE} set={setCE}/>&emsp;
        <CheckboxComponent text="PE" actual={PE} val={PE} set={setPE}/>&emsp;
        <CheckboxComponent text="FUT" actual={FUT} val={FUT} set={setFUT}/>&emsp;
        <button onClick={()=>refreshITM()}>refreshITM</button>
        Options ({getOptions().length})

        <ComboList combos={combos} clientId={""}/>
        <table className={"scrolldown"}>
            <thead>
            <tr>
                <th onClick={()=>setSorter(()=>AppUtil.genericSorterFun("timestamp", (a:Option)=>a.miniTick.nanoTime))}>time</th>
                <th>name</th>
                <th onClick={()=>setSorter(()=>AppUtil.genericSorterFun("strike", (a:Option)=>a.genInfo.strike))}>strike</th>
                <th>symbol</th>
                <th onClick={()=>setSorter(()=>AppUtil.genericSorterFun("buy", (a:Option)=>AppUtil.maxBuyer(a)))}>buyer </th>
                <th onClick={()=>setSorter(()=>AppUtil.genericSorterFun("sell", (a:Option)=>AppUtil.minSeller(a)))}>seller </th>
                <th onClick={()=>setSorter(()=>AppUtil.genericSorterFun("spread", (a:Option)=>AppUtil.minSeller(a) - AppUtil.maxBuyer(a)))}>spread </th>
                <th onClick={()=>setSorter(()=>AppUtil.genericSorterFun("diff", (a:Option)=>a.diff))}>diff</th>
                <th onClick={()=>setSorter(()=>AppUtil.genericSorterFun("last_price", (a:Option)=>a.miniTick.lastPrice))}>last price</th>
                <th onClick={()=>setSorter(()=>AppUtil.genericSorterFun("extrinsicBuy", (a:Option)=>a.extrinsicBuy))}>extrinsicBuy</th>
                <th onClick={()=>setSorter(()=>AppUtil.genericSorterFun("extrinsicSell", (a:Option)=>a.extrinsicSell))}>extrinsicSell</th>
                <th onClick={()=>setSorter(()=>AppUtil.genericSorterFun("intrinsic", (a:Option)=>a.intrinsic))}>intrinsic</th>
                <th>fut</th>
                <th>B/S Qty</th>
                {/*<th>ltt</th>*/}
                <th>expiry</th>
                <th>lot</th>
            </tr>
            </thead>
            <tbody>
            {getOptions().map(option => <OptionRowComponent
                key = {option.genInfo.tradingsymbol}
                option={option}
                clientId={clientId}
                enableTrading={enableTrading}
                getCombos = {getCombos}
               />)}
            </tbody>
        </table>

        </>

}

export default AllOptionComponent
